import React from "react";
import "./style.scss";

interface ReactionSummary {
  emoji: string;
  count: number;
  userIds: string[];
}

interface Props {
  reactions: ReactionSummary[];
  currentUserId: string;
  onToggle: (emoji: string) => void;
}

function ReactionBar({ reactions, currentUserId, onToggle }: Props) {
  if (!reactions || reactions.length === 0) return null;

  return (
    <div className="reaction-bar">
      {reactions.map((r) => {
        const isActive = r.userIds.includes(currentUserId);
        return (
          <button
            key={r.emoji}
            className={`reaction-bar__item${isActive ? " __active" : ""}`}
            onClick={() => onToggle(r.emoji)}
            type="button"
          >
            <span className="reaction-bar__emoji">{r.emoji}</span>
            <span className="reaction-bar__count">{r.count}</span>
          </button>
        );
      })}
    </div>
  );
}

export default ReactionBar;
